import { useAppStore } from "../store/appStore";

/**
 * マイクデバイス一覧と選択状態を提供する薄いフック。
 * デバイス列挙と許可管理は audioStreamService が行い、結果はストアに反映される。
 */
export const useMicrophone = () => {
	const microphones = useAppStore((state) => state.audioDevices);
	const selectedMicrophoneId = useAppStore((state) => state.selectedMicrophoneId);
	const setSelectedMicrophoneId = useAppStore((state) => state.setSelectedMicrophoneId);
	const micPermission = useAppStore((state) => state.micPermission);

	const selectMicrophone = (deviceId: string) => {
		if (selectedMicrophoneId === deviceId) return;
		setSelectedMicrophoneId(deviceId);
	};

	return {
		microphones,
		selectedMicrophoneId,
		selectMicrophone,
		micPermission,
	};
};
